import request from '@/utils/request'

/** 同一消息 id 在窗口期内重复「已读」只发一次请求，避免重复操作日志 */
const READ_NOTICE_DEDUPE_MS = 3000
const readNoticeInflight = new Map()
const readNoticeDoneAt = new Map()

/**
 * 通知管理API模块
 */
const noticeApi = {
  /**
   * 分页查询通知列表
   */
  queryNotices(data) {
    return request({url: '/service/notice/queryNotices',method: 'post',data})
  },
  // 新增通知
  addNotice(data) {
    return request({url: '/service/notice/addNotice',method: 'post',data})
  },
  // 修改通知状态
  upNoticeStat(id,stat) {
    return request({url: '/service/notice/upNoticeStat?id='+id+'&stat='+stat,method: 'put'})
  },
  // 修改通知信息
  updateNotice(data) {
    return request({url: '/service/notice/updateNotice',method: 'post',data})
  },
  // 统计我的未读消息数
  unreadNoticeNum() {
    return request({url: '/service/notice/unreadNoticeNum',method: 'get'})
  },
  // 分页查看我的消息
  queryMyNotices(data) {
    return request({url: '/service/notice/queryMyNotices',method: 'post',data})
  },
  // 全部已读我的消息
  allRead() {
    return request({url: '/service/notice/allRead',method: 'put'})
  },
  /**
   * 已读我的消息：3 秒内同 id 去重（进行中共用 Promise，成功后短窗口内不再请求）
   */
  readNotice(id) {
    if (id == null || id === '') {
      return Promise.reject(new Error('readNotice: missing id'))
    }
    const key = String(id)
    const now = Date.now()
    const doneAt = readNoticeDoneAt.get(key)
    if (doneAt != null && now - doneAt < READ_NOTICE_DEDUPE_MS) {
      return Promise.resolve({ code: 200, deduped: true })
    }
    const inflight = readNoticeInflight.get(key)
    if (inflight) {
      return inflight
    }
    const p = request({ url: '/service/notice/readNotice?id=' + key, method: 'put' })
      .then(res => {
        if (res && res.code === 200) {
          readNoticeDoneAt.set(key, Date.now())
        }
        return res
      })
      .finally(() => {
        readNoticeInflight.delete(key)
      })
    readNoticeInflight.set(key, p)
    return p
  },
  // 查询通知对应的用户
  noticeUsers(id) {
    return request({url: '/service/notice/noticeUsers?id='+id,method: 'get'})
  },
  // 查看我的弹窗消息
  queryMyOpenNotices() {
    return request({url: '/service/notice/queryMyOpenNotices',method: 'get'})
  },
}

export default noticeApi